import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import ItemsCarousel from 'react-items-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { storeAtom } from '../../../../atoms/Atoms';
import Card from '../../Card';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import Placeholder from './Placeholder';
import api from '../../../../api/api';

function Related({ product }) {
  const { t } = useTranslation();
  const store = useRecoilValue(storeAtom);
  const [products, setProducts] = useState([]);
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    if (product) {
      api.get(`businesses/${store.id}/${product}/related`)
        .then(
          (response) => {
            if (response.data.data) {
              setProducts(response.data.data.results);
            }
          },
          (error) => {
            if (
              error &&
              error.response &&
              error.response.status &&
              error.response.status === 401
            ) {
              console.log(error);
            } else {
              console.log(error);
            }
          }
        );
    }
  }, [product]);

  return (
    <div>
      <div className="text-2xl font-extrabold tracking-tight">
        {t('related_products')}
      </div>
      <ItemsCarousel
        placeholderItem={<Placeholder />}
        enablePlaceholder
        numberOfPlaceholderItems={5}
        infiniteLoop
        gutter={12}
        activePosition="left"
        showSlither
        firstAndLastGutter
        activeItemIndex={activeItemIndex}
        requestToChangeActive={setActiveItemIndex}
        numberOfCards={breakpoint === 1 ? 2 : 3}
        slidesToScroll={breakpoint === 1 ? 2 : 3}
        rightChevron={
          <button
            type="button"
            className="flex items-center justify-center h-10 w-10 bg-white shadow rounded-full"
          >
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        }
        leftChevron={
          <button
            type="button"
            className="flex items-center justify-center h-10 w-10 bg-white shadow rounded-full"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
        }
        classes={{
          itemsWrapper: 'w-full py-2',
          itemWrapper: 'w-full',
        }}
      >
        {_.map(products, (e) => (
          <Card
            key={e.id}
            product={e}
            name={e.name}
            description={e.description}
            image={(e.images.length > 0 && e.images[0].thumbnailUrl) || null}
            id={e.id}
            brand={e.brand}
            price={e.activePrice}
          />
        ))}
      </ItemsCarousel>
    </div>
  );
}

export default Related;
